import http from '../../../utils/services/http'

export const reciboPagamentoLotes = (lotes, pagamentos) => {
  return http.post('/api/financeiro/recibos/pagamentoLote', {
    lotes,
    pagamentos
  })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
export const reciboComissaoComitenteLotes = (lotes, pagamentos) => {
  return http.post('/api/financeiro/recibos/comissaoComitente', {
    lotes,
    pagamentos
  })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const notaArrematacao = (lotes, tipo = 'separado') => {
  return http.post('/api/financeiro/notaArrematacao', {
    lotes,
    tipo: tipo
  })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const termoRetirada = (lotes) => { // separado/unificado
  return http.post('/api/financeiro/termos/retirada', {
    lotes
  })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
